import { ReactNode } from "react";
import { CategoriesIcon } from "src/icons/CategoriesIcon";
import { BrandsIcon } from "src/icons/BrandsIcon";
import { ColoursIcon } from "src/icons/ColoursIcon";
import { PriceIcon } from "src/icons/PriceIcon";
import { SizeIcon } from "src/icons/SizeIcon";
import { PatternIcon } from "src/icons/PatternIcon";
import { StyleIcon } from "src/icons/StyleIcon";
import { Tag } from "src/icons/Tag";
import { Discount } from "src/icons";
import type { ListingFacetKeys } from "src/types/adapters/listing.type";

export const FACET_ICONS: Record<ListingFacetKeys, ReactNode> = {
  brands: <BrandsIcon />,
  category: <CategoriesIcon />,
  colors: <ColoursIcon />,
  discount: <Discount />,
  genders: <CategoriesIcon />,
  pattern: <PatternIcon />,
  price: <PriceIcon />,
  size: <SizeIcon />,
  style: <StyleIcon />,
  collections: <Tag />,
};
